import { Withdrawal } from './Withdrawal';

export default Withdrawal;
